export const LogoMark = ({ className = "h-8 w-8" }) => (
  <img src="/favicon.svg" alt="MKSL Zeichen" className={className} />
);
